import { Card, Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { Verified } from "../../../components/components/StatusIndicators";
import useAxios from "../../../hooks/useAxios";
import { checkPermission } from "../../../utils/checkPermission";

const UANSection = ({
  uanDetails,
  candidateDetails,
  getCandidateDetails,
  getUANDetails,
  setLoading,
}) => {
  const api = useAxios();
  const [InputUan, setInputUan] = useState("");
  const [uanErrorMessage, setUanErrorMessage] = useState("");
  const [uanModal, setUanModal] = useState(false);
  const [canSubmitUan, setCanSubmitUan] = useState(false);
  const toggleUan = () => setUanModal(!uanModal);

  useEffect(() => {
    const checkUanPermission = async () => {
      const role = localStorage.getItem("user.role");
      if (!role) return;
      const allowed = await checkPermission(role, "documents_module", "uan_submit");
      setCanSubmitUan(allowed);
    };
    checkUanPermission();
  }, []);

  useEffect(() => {
    setInputUan(candidateDetails?.UANnumber)
  },[candidateDetails?.UANnumber])

  const handleInputUanChange = (e) => {
    setUanErrorMessage("");
    if (e.target.value?.length > 12) return;
    setInputUan(e.target.value);
  };

  const handleInputUanSubmit = async () => {
    setUanErrorMessage("");
    const trimmedUan = InputUan ? InputUan.toString().trim() : "";
    if (!trimmedUan) {
      setUanErrorMessage("Please enter a UAN Number");
      return;
    }

    if (trimmedUan.length !== 12 || !/^\d{12}$/.test(trimmedUan)) {
      setUanErrorMessage("UAN Number must be a valid 12-digit number");
      return;
    }
    try {
      setLoading(true);
      const requestData = {
        candidateId: candidateDetails?._id,
        UANNo: trimmedUan,
      };

      const result = await api.post(
        "/candidatedocuments/verifyUANNo",
        requestData,
        {
          tokenType: "user",
        }
      );

      if (result.status === 200) {
        setUanErrorMessage("");
        await getUANDetails();
        message.success(result?.data?.message || "UAN verified successfully");
      }
      await getCandidateDetails();
    } catch (error) {
      console.error(
        "UAN Verification Error:",
        error?.response?.data || error
      );
      const errorMsg =
        error?.response?.data?.error?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "UAN Verification Failed";
      setUanErrorMessage(
        typeof errorMsg === "string" ? errorMsg : JSON.stringify(errorMsg)
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Card className="border bg-white col-md-12 mb-2" title={`UAN Details`}>
        <div className="row">
          <div className="col-md-10">
            <div className="card p-2 d-flex flex-row justify-content-between">
              <div className="w-100">
                <strong>
                  UAN Details : {uanDetails?.uan ? uanDetails?.uan : ""}
                </strong>
                {!uanDetails?.employment_history ||
                uanDetails?.employment_history?.length === 0 ? (
                  <>
                    {candidateDetails?.EPFO === "yes" ? (
                      <div className="row d-flex align-items-start mt-1">
                        <div className="col-md-6 mt-2">
                          <Input
                            style={{ borderRadius: "4px", height: "30px" }}
                            type="number"
                            max={12}
                            placeholder="Enter UAN Number"
                            value={InputUan}
                            onChange={handleInputUanChange}
                            disabled={
                              candidateDetails?.UANnumber &&
                              candidateDetails?.UANnumber !== ""
                            }
                          />
                          {uanErrorMessage && (
                            <div className="text-danger mt-2">
                              {uanErrorMessage}
                            </div>
                          )}
                        </div>
                        {canSubmitUan && (
                        <div className="col-md-2 mt-2">
                          <button
                            className={
                              InputUan?.length === 12 &&
                              !(
                                candidateDetails?.UANnumber &&
                                candidateDetails?.UANnumber !== ""
                              )
                                ? "btn-primary"
                                : "btn-secondary"
                            }
                            style={{
                              color: "#fff",
                              height: "30px",
                              borderRadius: "4px",
                              padding: "0 15px",
                              border: "none",
                            }}
                            onClick={handleInputUanSubmit}
                            disabled={
                              InputUan?.length !== 12 ||
                              (candidateDetails?.UANnumber &&
                                candidateDetails?.UANnumber !== "")
                            }
                          >
                            Submit
                          </button>
                        </div>
                        )}
                      </div>
                    ) : (
                      <div className="d-flex mt-3">UAN Details not found</div>
                    )}
                  </>
                ) : (
                  <>
                    {uanDetails?.employment_history && (
                      <div className="row mt-2">
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Name :</strong>
                            {uanDetails?.employment_history[0]?.name}
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Guardian Name :</strong>
                            {uanDetails?.employment_history[0]?.guardian_name}
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Establishment Name :</strong>
                            {
                              uanDetails?.employment_history[0]
                                ?.establishment_name
                            }
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Wage Month :</strong>
                            {uanDetails?.employment_history[0]?.wage_month}
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Date of Joining :</strong>
                            {uanDetails?.employment_history[0]?.date_of_joining}
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Date of Exit :</strong>
                            {uanDetails?.employment_history[0]?.date_of_exit
                              ? ""
                              : "Not Found"}
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="card px-2 py-1">
                            <strong>Last PF Submitted :</strong>
                            {
                              uanDetails?.employment_history[0]
                                ?.last_pf_submitted
                            }
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className="p-0.5">
                {candidateDetails?.EPFO === "yes" &&
                  candidateDetails?.UANnumber &&
                  candidateDetails?.UANnumber !== "" && <Verified />}
              </div>
            </div>
          </div>
          {uanDetails?.employment_history &&
            uanDetails?.employment_history?.length !== 0 && (
              <div className="col-md-2">
                <div className="card p-2">
                  <strong>Action: </strong>
                  <div>
                    <button
                      className={`btn-sm ${
                        uanDetails?.employment_history?.length === 0
                          ? "btn-secondary"
                          : "btn-primary"
                      }`}
                      onClick={toggleUan}
                      disabled={uanDetails?.employment_history?.length === 0}
                    >
                      View more{" "}
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>
      </Card>
      <Modal
        centered
        open={uanModal}
        onCancel={toggleUan}
        width={800}
        footer={null}
        title="UAN Details"
      >
        <div className="table-responsive">
          <table id="table-datatable" className="table bg-white border">
            <tbody>
              {uanDetails?.employment_history &&
                uanDetails?.employment_history?.map((employement, index) => {
                  return (
                    <tr className="table-column-head" key={index}>
                      <td>
                        <p>
                          <b>Name</b> : {employement?.name}{" "}
                        </p>
                        <p>
                          <b>Guardian Name</b> : {employement?.guardian_name}{" "}
                        </p>
                        <p>
                          <b>Establishment Name</b> :{" "}
                          {employement?.establishment_name}{" "}
                        </p>
                        <p>
                          <b>Wage Month</b> : {employement?.wage_month}{" "}
                        </p>
                        <p>
                          <b>Date of Exit</b> :{" "}
                          {employement?.date_of_exit ? "" : "Not Found"}{" "}
                        </p>
                        <p>
                          <b>Last PF Submitted</b> :{" "}
                          {employement?.last_pf_submitted}{" "}
                        </p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};

export default UANSection;
